module.exports = __webpack_public_path__ + "static/media/sun.626d64aa.svg";